"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Cookies = require("js-cookie");
var UUID = require("uuid");
var COOKIE_NAME = 'elog-analytics-2';
var DEFAULT_DOMAIN = '.reverb.com';
var FIVE_YEARS_IN_DAYS = 1825;
var CONFIGURATION = {
    domain: DEFAULT_DOMAIN,
};
function configure(options) {
    Object.assign(CONFIGURATION, options);
}
function getOrSetTrackingId() {
    var cookie = Cookies.getJSON(COOKIE_NAME);
    if (!cookie || !cookie.id) {
        return buildAndSetCookie();
    }
    return cookie.id;
}
function buildAndSetCookie() {
    var cookieId = UUID.v4();
    Cookies.set(COOKIE_NAME, {
        id: cookieId,
    }, {
        expires: FIVE_YEARS_IN_DAYS,
        domain: CONFIGURATION.domain,
    });
    return cookieId;
}
exports.default = {
    configure: configure,
    trackingId: getOrSetTrackingId,
};



//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.ecs-deploy.production/build/src/node_modules/@reverbdotcom/elog/dist/analytics-cookie.js
// module id = Dvme
// module chunks = 20